import React from 'react';
import { connect } from 'react-redux';

class EjemploMostrar extends React.Component {
  render() {
    return (<div>Ejemplo</div>);
  }
}

export default connect(
  null,
  null,
)(EjemploMostrar);
